/**
 * API Configuration and Helper Functions
 */

// The base URL for your PHP backend. 
// Change this when you deploy to a live server.
export const API_BASE = 'https://apply.sliitleo.org/api';

/**
 * Helper function to resolve image URLs cleanly across dev and production.
 * @param {string} imagePath - The path stored in the database.
 * @returns {string} - The full URL to the image.
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';

  // If the path is already a full URL (starts with http)
  if (imagePath.startsWith('http')) {
    return imagePath;
  }

  // If it's an uploaded image starting with /leo_apply/api/
  if (imagePath.startsWith('/api/')) {
    // Extract the host part from API_BASE to construct the full URL
    const url = new URL(API_BASE);
    return `${url.protocol}//${url.host}${imagePath}`;
  }

  // If it starts with / (root relative but not the API path)
  if (imagePath.startsWith('/')) {
    // Ensure we don't double slash with PUBLIC_URL
    const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
    return (process.env.PUBLIC_URL || '') + '/' + cleanPath;
  }

  // Default: Fallback to React's public folder
  return (process.env.PUBLIC_URL || '') + '/' + imagePath.replace(/^\//, '');
};
